export default "__VITE_ASSET__1IwmCsGc__"